import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

import {UnitType} from "../types"; // Import UnitType

interface UnitsSelectorProps {
    selectedUnit: UnitType;
    setSelectedUnit: (value: UnitType) => void;
}

const UnitsSelector: React.FC<UnitsSelectorProps> = ({ selectedUnit, setSelectedUnit }) => {
    const handleUnitChange = (event: SelectChangeEvent<UnitType>) => {
        setSelectedUnit(event.target.value as UnitType);
    };

    return (
        <FormControl sx={{ minWidth: 100, marginLeft: '1rem' }}>
            <InputLabel>Unit</InputLabel>
            <Select
                value={selectedUnit}
                onChange={handleUnitChange}
                label="Unit"
                size="small"
            >
                <MenuItem value="mg">mg</MenuItem>
                <MenuItem value="µg">µg</MenuItem>
                <MenuItem value="microg">microg</MenuItem>
                <MenuItem value="ng">ng</MenuItem>
            </Select>
        </FormControl>
    );
};

export default UnitsSelector;
